import { AUTHENTICATION } from "../constants";

const initialState = { id: "", type: "" };

const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AUTHENTICATION:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default userReducer;
